module.exports = __webpack_public_path__ + "img/photo-veroniquelesourd-accueil-02.09b17397.jpeg";